import React from 'react';
import { List } from 'semantic-ui-react';
import clsx from 'clsx';
import RequestApproversListItem from './RequestApproversListItem';

const RequestApproversList = ({ className, items }) => (
  <List className={clsx('aridhia-request-approvers-list', className)}>
    {items.map((member) => (
      <RequestApproversListItem key={`request_approver_${member.uuid || member.code}`} member={member} />
    ))}
  </List>
);

export default RequestApproversList;
